module.exports = __webpack_public_path__ + "static/media/gb-nir.6c82e43e.svg";